import React, { useEffect, useState, useMemo } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import {
  FaClipboard,
  FaClock,
  FaDollarSign,
  FaFileAlt,
  FaFileInvoice,
  FaGavel,
  FaList,
  FaReceipt,
  FaUser,
  FaUsers,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../assets/styles/index.css";
import { useGetMenuListMutation } from "../../slices/adminApiSlice";
import { parseUserInfo } from "../../utils/parseUtil";

const iconStyles = {
  salarySlip: { color: "#ff5733" }, // Orange
  leaveRegister: { color: "#33c4ff" }, // Light Blue
  personalFile: { color: "#33ff5a" }, // Light Green
  attendanceRegister: { color: "#f4d033" }, // Yellow
  leaveRegister14_15: { color: "#a833ff" }, // Purple
  salarySheet: { color: "#33a1ff" }, // Blue
  bonusMonthly: { color: "#ff33a1" }, // Pink
  fullAndFinal: { color: "#ffb533" }, // Light Orange
  overtimeRegister: { color: "#33ffed" }, // Teal
  bonusForm: { color: "#a1ff33" }, // Lime Green
  gratuityReport: { color: "#ff5733" }, // Red
  form21: { color: "#33ff6e" }, // Mint Green
  form22: { color: "#6e33ff" }, // Indigo
  form24: { color: "#ff6e33" }, // Coral
  form25: { color: "#ffb633" }, // Golden
  faceAuth: { color: "#a1ff33" }, // Lime Green
  leaveManagement: { color: "#ff33a1" }, // Pink
  attendanceManagement: { color: "#33a1ff" }, // Blue
};

const DashboardScreen = () => {
  const [menuList, setMenuList] = useState([]);
  const { userInfo } = useSelector((state) => state.auth);

  const iconAndUrl = useMemo(() => ({
    1: {
      title: "Salary Slip",
      icon: <FaFileInvoice size={40} style={iconStyles.salarySlip} />,
      link: "/salary-slip",
    },

    2: {
      title: "Salary Sheet and Summary",
      icon: <FaReceipt size={40} style={iconStyles.salarySheet} />,
      link: "/salary-sheet-summary",
    },

    3: {
      title: "Bonus Form C",
      icon: <FaList size={40} style={iconStyles.bonusForm} />,
      link: "/bonus-form-c",
    },

    4: {
      title: "Form 24 (Contract Act)",
      icon: <FaClipboard size={40} style={iconStyles.form24} />,
      link: "/form-24",
    },

    5: {
      title: "Employee Personal File Data",
      icon: <FaUser size={40} style={iconStyles.personalFile} />,
      link: "/employee-personal-file-data",
    },

    6: {
      title: "Bonus Monthly Summary",
      icon: <FaList size={40} style={iconStyles.bonusMonthly} />,
      link: "/bonus-monthly",
    },

    7: {
      title: "Gratuity Report",
      icon: <FaGavel size={40} style={iconStyles.gratuityReport} />,
      link: "/gratuity-report",
    },

    8: {
      title: "Form 25 (Contract Act)",
      icon: <FaClipboard size={40} style={iconStyles.form25} />,
      link: "/form-25",
    },

    9: {
      title: "Attendance Register (Form-12)",
      icon: <FaClock size={40} style={iconStyles.attendanceRegister} />,
      link: "/attendance-register-form-12",
    },

    10: {
      title: "Employee Full and Final",
      icon: <FaUsers size={40} style={iconStyles.fullAndFinal} />,
      link: "/employee-full-final",
    },

    11: {
      title: "Form 21 (Factory Act)",
      icon: <FaClipboard size={40} style={iconStyles.form21} />,
      link: "/form-21",
    },

    12: {
      title: "Leave Register Form No 14 & 15",
      icon: <FaFileAlt size={40} style={iconStyles.leaveRegister14_15} />,
      link: "/leave-register-form-14-15",
    },

    13: {
      title: "Overtime Register",
      icon: <FaDollarSign size={40} style={iconStyles.overtimeRegister} />,
      link: "/overtime-register",
    },

    14: {
      title: "Form 22 (Factory Act)",
      icon: <FaClipboard size={40} style={iconStyles.form22} />,
      link: "/form-22",
    },

    // 15: {
    //   title: "Leave Register Form-14",
    //   icon: <FaCalendarAlt size={40} style={iconStyles.leaveRegister} />,
    //   link: "/leave-register-form-14",
    // },
  

    // 17: {
    //   title: "Leave Application Management",
    //   icon: <FaCalendarAlt size={40} style={iconStyles.leaveManagement} />,
    //   link: "/leave-application-management",
    // },
    // 18: {
    //   title: "Attendance Management",
    //   icon: <FaCalendarCheck size={40} style={iconStyles.attendanceManagement} />,
    //   link: "/admin-attendance-management",
    // },
  }), []);

  const [getMenuList] = useGetMenuListMutation();
  const reqCompanyCode = userInfo[13]?.InfoField;

  useEffect(() => {
    const fetchMenuList = async () => {
      const formData = new FormData();

      formData.append("title", "GetMenuList");
      formData.append("ReqModule", "Admin");
      formData.append("ReqCompanyCode", reqCompanyCode);

      const res = await getMenuList(formData);
      const parsedOptions = parseUserInfo(res);

      if (parsedOptions[0].ActionType > 0) {
        let menuList = JSON.parse(parsedOptions[0].JSONData1);
        console.log(menuList, 222);
        
        // Add Leave Application Management and Attendance Management menu items for admin users
        if (userInfo[1]?.InfoField2 === "3") {
          menuList = [
            ...menuList,
            {
              MenuID: "17",
              MainMenu: "Leave Application Management"
            },
            {
              MenuID: "18",
              MainMenu: "Attendance Management"
            }
          ];
        }

        const enrichedData = menuList
          .filter((item) => {
            const mapping = iconAndUrl[item.MenuID];
            if (!mapping) {
              console.log(`Skipping item with MenuID: ${item.MenuID} — no mapping found`);
              return false;
            }
            return true;
          })
          .map((item) => {
            const mapping = iconAndUrl[item.MenuID];
            return {
              ...item,
              icon: mapping.icon,
              link: mapping.link,
            };
          });

        setMenuList(enrichedData);
      }
    };

    fetchMenuList();
  }, [reqCompanyCode, getMenuList, userInfo, iconAndUrl]);

  return (
    <div className="modern-dashboard">
      <Container fluid className="px-4 py-3">
        {/* Page Header */}
        <div className="dashboard-header mb-4">
          <h2 className="dashboard-title">Admin Dashboard</h2>
        </div>

        {/* Admin Tools Grid */}
        <Row className="g-4">
          {menuList.map((item) => (
            <Col key={item.MenuID} xs={12} sm={6} lg={4} xl={3} className="mb-3">
              <Link to={item?.link} className="text-decoration-none">
                <Card className="admin-tool-card h-100 border-0 shadow-sm">
                  <Card.Body className="p-4 text-center">
                    <div className="admin-icon-container mb-3">
                      <div className="admin-icon">
                        {item?.icon}
                      </div>
                    </div>
                    <h6 className="admin-tool-title">{item?.MainMenu}</h6>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default DashboardScreen;
